import React from 'react';

import moment from 'moment-timezone';
import { Table } from 'react-bootstrap';

import Sorter from '../../utils/Sorting/Sorter';
import { EDT } from '../../../infrastructure/constants/common';
import '../../../styles/components/PartiesList.css';
import { PARTY_TYPES } from '../../forms/PartiesFilterForm';
import { isMobileResolution } from '../../../infrastructure/utils/common';

import PartiesMobileList from './PartiesMobileList';

const PartyTypesMap = new Map(PARTY_TYPES.map(item => [item.name, item.label]));

class PartiesList extends React.PureComponent {
  handleOnClick = event => {
    event.preventDefault();
    // TODO: Fix this the next time the file is edited.
    // @ts-ignore
    // eslint-disable-next-line react/prop-types
    const { handleOnClick } = this.props;
    handleOnClick(event, event.currentTarget.getAttribute('href'));
  };

  changeSort = event => {
    // TODO: Fix this the next time the file is edited.
    // @ts-ignore
    // eslint-disable-next-line react/prop-types
    const { changeSort } = this.props;
    event.stopPropagation();
    event.preventDefault();

    changeSort(event.currentTarget.getAttribute('name'));
  };

  getPartyDate = item => {
    const tz = item.tz ? item.tz : EDT;
    return item.startDate
      ? `${moment(item.startDate).tz(tz).format('MM/DD/YY')} - ${moment(
          item.endDate
        )
          .tz(tz)
          .format('MM/DD/YY z')}`
      : 'Dates Unknown';
  };

  render() {
    // TODO: Fix this the next time the file is edited.
    // @ts-ignore
    // eslint-disable-next-line react/prop-types
    const { content, activeSort, handleOnClick } = this.props;
    if (isMobileResolution()) {
      return (
        <PartiesMobileList
          content={content}
          getPartyDate={this.getPartyDate}
          onClick={handleOnClick}
        />
      );
    }

    return (
      <div className='partieslist'>
        <Table hover>
          <thead>
            <tr>
              <th
                // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
                // @ts-ignore
                name='partyLocation.address'
                className='sortColumn'
                onClick={this.changeSort}
              >
                Location{' '}
                <Sorter activeSort={activeSort} name='partyLocation.address' />
              </th>
              <th
                // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
                // @ts-ignore
                name='startDate'
                className='sortColumn'
                onClick={this.changeSort}
              >
                Dates <Sorter activeSort={activeSort} name='startDate' />
              </th>
              <th>Party Type</th>
              <th
                // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
                // @ts-ignore
                name='partyName'
                className='sortColumn'
                onClick={this.changeSort}
              >
                Name <Sorter activeSort={activeSort} name='partyName' />
              </th>
              <th>Description</th>
              <th
                // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
                // @ts-ignore
                name='createdAt'
                className='sortColumn'
                onClick={this.changeSort}
              >
                Created at <Sorter activeSort={activeSort} name='createdAt' />
              </th>
            </tr>
          </thead>
          <tbody>
            {content // TODO: Fix this the next time the file is edited.
              // eslint-disable-next-line react/prop-types
              .map(item => {
                const tz = item.tz ? item.tz : EDT;
                return (
                  <tr
                    key={item.partyId}
                    // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
                    // @ts-ignore
                    href={`/party/${item.partyId}`}
                    className='listrow'
                    onClick={this.handleOnClick}
                  >
                    <td style={{ width: '20%' }}>
                      {item.partyLocation
                        ? item.partyLocation.address
                        : 'Location Unknown'}
                    </td>
                    <td style={{ width: '20%' }}>{this.getPartyDate(item)}</td>
                    <td style={{ width: '20%' }}>
                      {PartyTypesMap.get(item.partyType) ?? ''}
                    </td>
                    <td style={{ width: '20%' }}>{item.partyName}</td>
                    <td
                      style={{ maxWidth: '177px' }}
                      title={item.partyDescription}
                    >
                      <span className='big-text-field'>
                        {item.partyDescription}
                      </span>
                    </td>
                    <td style={{ width: '120px' }}>
                      {moment(item.createdAt).tz(tz).format('MM/DD/YY')}
                    </td>
                  </tr>
                );
              })}
          </tbody>
        </Table>
      </div>
    );
  }
}

export default PartiesList;
